/** A referential list of job functions: no tenant, no parameter. */
class FetchStaffFunctions {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchStaffFunctions;
